import React from 'react'
import {
  Beta,
  IconChevronLeftDefault,
  IconChevronRightDefault,
} from '@mc/design-system'
import classes from './Pagination.module.scss'

export const Pagination = ({
  pageCountOffset = 0,
}: {
  pageCountOffset?: number
}) => {
  const { pages, page, prevPage, nextPage, loops } = Beta.useCarousel()
  const isActive = (i: number) => page % pages === i

  const handleNextPage = () => {
    if (loops || page + 1 < pages - pageCountOffset) {
      nextPage()
    }
  }

  return (
    <div className='d-flex justify-content-center mc-mt-6'>
      <div className='d-flex align-items-center flex-gap-2'>
        <button
          onClick={prevPage}
          className={`mc-clickable d-flex align-items-center justify-content-center mc-mr-3 ${classes.paginationButton}`}
          disabled={!loops && page === 0}
        >
          <IconChevronLeftDefault size='sm' style={{ stroke: 'white' }} />
        </button>
        {Array.from({ length: pages - pageCountOffset }).map((_, i) => (
          <div
            key={i}
            className='mc-mt-1'
            style={{
              width: 'var(--mc-scale-2)',
              height: 'var(--mc-scale-2)',
              borderRadius: 20,
              backgroundColor: isActive(i)
                ? 'white'
                : 'rgba(255, 255, 255, 0.3)',
            }}
          />
        ))}
        <button
          onClick={handleNextPage}
          className={`mc-clickable d-flex align-items-center justify-content-center mc-ml-3 ${classes.paginationButton}`}
          disabled={!loops && page + 1 >= pages - pageCountOffset}
        >
          <IconChevronRightDefault size='sm' style={{ stroke: 'white' }} />
        </button>
      </div>
    </div>
  )
}
